module.exports = "/assets/06b27ee359655af9b7b256e703f075f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/CI.png
// module id = 2394
// module chunks = 0